import React from 'react';
import { Modal } from '../common/Modal';
import { SalesForm } from './SalesForm';
import { SaleFormData, Sale } from '../../types/Sales';
import { Product } from '../../types/Product';

interface SalesModalProps {
  open: boolean;
  onClose: () => void;
  onSave: (data: SaleFormData) => void;
  sale?: Sale;
  products: Product[];
  loading?: boolean;
}

export const SalesModal: React.FC<SalesModalProps> = ({
  open,
  onClose,
  onSave,
  sale,
  products,
  loading,
}) => {
  const formRef = React.useRef<HTMLFormElement>(null);

  const handleSave = () => {
    if (formRef.current) {
      formRef.current.requestSubmit();
    }
  };

  const handleSubmit = (data: SaleFormData) => {
    onSave(data);
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      onSave={handleSave}
      title={sale ? 'Satış Düzenle' : 'Yeni Satış Ekle'}
      loading={loading}
    >
      <SalesForm
        initialData={sale}
        onSubmit={handleSubmit}
        products={products}
        loading={loading}
        formRef={formRef}
      />
    </Modal>
  );
};

